import { v4 as uuidv4 } from 'uuid';
//
import { isFeatureActive } from '@redux/reducers/config/configReducer';
import featureConstants from '@constants/featureConstants';
import { recordImpressions } from '@redux/actions/app/appActions';
import { sendNewRelicCustomEvent } from '@utils/logging/logging-utils';

import getKountSDK from './getKountSDK';
import { getTargetBIN } from './getTargetBIN';

export const targetBINs = [{
  bin: '492915',
}, {
  bin: '492181',
  featureSwitch: featureConstants.TRA_VISA_BINS,
}, {
  bin: '446291',
  featureSwitch: featureConstants.TRA_VISA_BINS,
}, {
  bin: '454313',
  featureSwitch: featureConstants.TRA_EXTRA_VISA,
}, {
  bin: '465944',
  featureSwitch: featureConstants.TRA_EXTRA_VISA,
}];

export const getTargetNumber = ({
  cardDetailsPayload,
  cardToBeStored,
  savedCardPayment,
}) => {
  if (savedCardPayment) return cardDetailsPayload?.cardNumber;

  if (!cardToBeStored) return cardDetailsPayload?.creditCardDetails?.number;

  return undefined;
};

export const shouldKount = params => (dispatch, getState) => {
  const {
    cardDetailsPayload,
    cardToBeStored,
    savedCardPayment,
    outstandingBalanceRaw,
  } = params;

  if (outstandingBalanceRaw < 440) {
    const number = getTargetNumber({
      cardDetailsPayload,
      cardToBeStored,
      savedCardPayment,
    });

    let targetBIN;

    targetBIN = getTargetBIN(number, targetBINs);

    if ((targetBIN || number?.startsWith('5')) && (savedCardPayment || !cardToBeStored)) {
      const state = getState();
      const {
        config: {
          features = [],
        } = {},
      } = state;

      const targetFeatureSwitch = targetBIN?.featureSwitch;

      // BIN is permanently going through kount
      if (!targetFeatureSwitch) {
        return true;
      }

      // BIN is being AB tested
      const targetFeature = features?.find(
        feature => feature.id === targetFeatureSwitch,
      ) ?? {};

      const targetFeatureImpressionId = targetFeature.impressionId;
      if (targetFeatureImpressionId) dispatch(recordImpressions(targetFeatureImpressionId));
      if (isFeatureActive(state, targetFeatureSwitch)) return true;
    }
  }

  return false;
};

export function isTestEnvironment() {
  if (window.publicJLSiteDomain?.includes('johnlewis')) return false;

  return true;
}

export function getEnvironmentParam() {
  if (isTestEnvironment()) return 'TEST';

  return 'PROD';
}

export function generateKountSessionId() {
  return uuidv4().replace(/-/g, '');
}

export const initKount = params => (dispatch, getState) => (
  new Promise((resolve) => {
    const {
      callbackFunction,
      callbackParams,
    } = params;

    if (!dispatch(shouldKount(params))) {
      resolve(dispatch(callbackFunction(callbackParams)));
    } else {
      let timeoutHappened = false;

      const timeout = setTimeout(() => {
        const {
          bff: {
            sessionId,
          } = {},
          orderForm: {
            omsOrderId,
          } = {},
        } = getState() ?? {};

        timeoutHappened = true;
        sendNewRelicCustomEvent('kount-timeout', {
          sessionId,
          omsOrderId,
        });
        resolve(dispatch(callbackFunction(callbackParams)));
      }, 7000);

      const kountConfig = {
        clientID: '888840',
        environment: getEnvironmentParam(),
        isSinglePageApp: true,
        isDebugEnabled: isTestEnvironment(),
        callbacks: {
          'collect-end': (responseParams) => {
            if (!timeoutHappened) {
              clearTimeout(timeout);

              resolve(dispatch(callbackFunction({
                ...callbackParams,
                body: {
                  ...callbackParams.body,
                  fraudSessionId: responseParams?.SessionID,
                },
              })));
            }
          },
        },
      };

      const kountSDK = getKountSDK();

      const sdk = kountSDK(kountConfig, generateKountSessionId());
      if (!sdk) {
        // SDK failed for some reason so proceed to payment
        clearTimeout(timeout);
        resolve(dispatch(callbackFunction(callbackParams)));
      }
    }
  })
);

export default initKount;
